import { fetchAuthReport, GET_TAXINVOICE_LIST_ACTION_TYPE, getTaxInvoiceListUrl, DOWNLOAD_TAXINVOICE_INVOICE, headers, } from "../../../utils/constants";
import { axiosGet, axiosPost } from "../../../react_axios/Axios";

export const get_taxinvoiceList_action =
    (ApplicantName, taxinvoice_date, taxinvoice_no, application_no) => async (dispatch) => {
        try {
            const mapdata = {
                user_id: sessionStorage.getItem("user_id"),
                award_event_id: sessionStorage.getItem("award_event_id"),
                applicant_name: ApplicantName,
                taxinvoice_date: taxinvoice_date,
                taxinvoice_no: taxinvoice_no,
                application_no: application_no
            };
            const res = await axiosGet(getTaxInvoiceListUrl, mapdata, headers);
            dispatch({
                type: GET_TAXINVOICE_LIST_ACTION_TYPE,
                payload: res,
            });
            return res;
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const download_taxinvoice_action =
    (application_form_id, TaxInvoiceID) => async (dispatch) => {
        try {
            var list = [];
            const mapdata = {
                "ParameterName": "@application_form_id",
                "ParameterValue": application_form_id,
                "ParameterDataType": "int"
            }
            const mapdata2 = {
                "ParameterName": "@tax_invoice_id",
                "ParameterValue": TaxInvoiceID,
                "ParameterDataType": "int"
            }
            list.push(mapdata);
            list.push(mapdata2);
            const mapData = {
                "user_id": sessionStorage.getItem("user_id"),
                "report_name": "taxinvoice.rpt",
                "report_file_name": `taxinvoice${application_form_id}`,
                "config_id": 0,
                "parameter_details": list,

            }
            const res = await axiosPost(fetchAuthReport, mapData, headers);
            dispatch({
                type: DOWNLOAD_TAXINVOICE_INVOICE,
                payload: res,
            });

            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };